import type { JSX } from "react";

/**
 * Live online/offline indicator (#228 Phase 2). A small dot + label: online
 * carries semantic success colour, offline stays neutral (color scarcity).
 * Tokens-only via cc-tone-*; sentence-case Chinese labels, no icons/emojis.
 */
export function OnlineIndicator({ online }: { online: boolean }): JSX.Element {
  const tone = online ? "ok" : "mute";
  return (
    <span className={`cc-tag cc-tone-${tone}`}>{online ? "在线" : "离线"}</span>
  );
}
